import { Component, Input, OnDestroy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStrategy from '@strategy/reducers';

import { CustomerInvestmentData } from '@shared/models/Strategy';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-strategy-3a-portfolio-fees',
  templateUrl: './strategy-3a-portfolio-fees.component.html',
  styleUrls: ['../strategy-portfolio-fees/strategy-portfolio-fees.component.scss', './strategy-3a-portfolio-fees.component.scss'],
  standalone: false
})
export class Strategy3APortfolioFeesComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() language;
  showMore: boolean;

  iconArray = ['cover1', 'cover2', 'cover4'];
  feesDetails = [
    {
      title: 'new_strategy.portfolio_screen.graph_box.costs.details-3a.assetmanagement',
      fees: '0.35%'
    },
    {
      title: 'new_strategy.portfolio_screen.graph_box.costs.details-3a.liberty',
      fees: '0.30%'
    },
    {
      title: 'new_strategy.portfolio_screen.graph_box.costs.details-3a.bank',
      fees: '0.15%'
    }
  ];

  annualFee = 0.8;
  showCostNote = true;
  investmentData: CustomerInvestmentData;

  constructor(
    private store: Store,
    private trackingService: TrackingService
  ) {
    this.store.pipe(select(fromStrategy.selectCustomerInvestmentData), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.showCostNote = response.stock_split !== 1;
    });
  }

  toggleShowMore(showMore: boolean) {
    this.showMore = showMore;
    this.trackingService.trackActivity(`[Button] Fee details: Show ${this.showMore ? 'more' : 'less'}`);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
